
import AddPostIcon from '../../icons/AddPostIcon.vue';
export default {
  name: 'ShowCreatePostRounded',
  components: { AddPostIcon },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
